import React from "react";
import { useTranslation } from "react-i18next";
import { getLabelPaymentMethodByType , getLabelPaymentMethod} from "utils/stringUtils";

interface PaymentMethodDisplayProps {
  payment: {
    paymentMethod?: {
      type: string;
      name?: string;
    };
    bankName?: string;
    chequeReference?: string;
    transferProof?: string; 
  };
  showDetails?: boolean;
  showProofLink?: boolean;
  className?: string;
}

const PaymentMethodDisplay: React.FC<PaymentMethodDisplayProps> = ({
  payment,
  showDetails = true,
  showProofLink = true,
  className = "",
}) => {
  const { t } = useTranslation();
  const methodType = payment.paymentMethod?.type || "";
  const methodName = getLabelPaymentMethodByType(methodType);

  const handleProofClick = () => {
    if (payment.transferProof) {
        window.open(payment.transferProof, "_blank");
    }
  };

  const renderContent = () => {
    if (methodType === "bank_check") {
      return (
        <div className="payment-method-details">
          <div className="fw-medium">{methodName}</div>
          {showDetails && payment.bankName && (
            <small className="text-muted d-block">
              {payment.bankName}
            </small>
          )}
          {showDetails && payment.chequeReference && (
            <small className="text-muted d-block">
              #{payment.chequeReference}
            </small>
          )}
        </div>
      );
    }

    if (methodType === "bank_transfer") {
      return (
        <div className="payment-method-details">
          <div className="fw-medium">{methodName}</div>
          {showDetails && payment.transferProof && showProofLink && (
            <small 
              className="text-success d-block" 
              style={{ cursor: "pointer" }} 
              onClick={handleProofClick}
            >
              <i className="ti ti-file-check me-1"></i>
              {t("paymentMethod.form.transfer_proof")}
            </small>
          )}
        </div>
      );
    }

    if (methodType === "cash") {
      return (
        <div className="payment-method-details">
          <div className="fw-medium">{methodName}</div>
        </div>
      );
    }

    const displayName = payment.paymentMethod?.name 
      ? getLabelPaymentMethod(payment.paymentMethod.name)
      : methodName;
    
    return <span>{displayName}</span>;
  };

  return <div className={`payment-method-display ${className}`}>{renderContent()}</div>;
};

export default PaymentMethodDisplay;